// @ts-check
import { get } from "./fetchWrapper";

const BONUSSAMMELN_SNIPPET = `/api/include/bonussammeln/artikel/daten/`;

export function getSnippet(model) {
  return get(BONUSSAMMELN_SNIPPET + model[3]+"?betrag="+model[1]+"&preisbindung="+model[2]+"&shopId="+model[0], "text/html", 20000);
}